<mat-toolbar class="p-0 mat-elevation-z1">

  @if (showLoadingBar) {
    <mat-progress-bar class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>
  }

  <!--<div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">-->

  <!--<div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">-->

  <button mat-button class="toggle-button-navbar mat-icon-button"
    fuseNavbarVertical="toggleBar" fxHide.gt-md>
    <mat-icon>menu</mat-icon>
  </button>

  <div class="" fxFlex="auto" fxLayout="row" fxLayoutAlign="end">
    @if (platforms && platforms.length && platforms.length > 1 && selectedPlatform) {
      <div class="hide-on-mobile">
        <button mat-button [matMenuTriggerFor]="platformMenu"
          class="user-button">
          <div fxLayout="row" fxLayoutAlign="center center">
            <span class="platform mr-12" fxHide fxShow.gt-sm> {{selectedPlatform.title}}</span>
            <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
          </div>
        </button>
      </div>
    }
    <mat-menu #platformMenu="matMenu">
      @for (platform of platforms; track platform.id) {
        <button mat-menu-item (click)="selectPlatform(platform)">
          <span>{{platform.title}}</span>
        </button>
      }
    </mat-menu>
    @if (organizationName) {
      <div class='hide-on-mobile org-name'
      >{{organizationType}} {{organizationName}}</div>
    }
    @if (city) {
      <div class='hide-on-mobile flex' style="flex: 1 auto; margin: 14px;">
        <div>{{city?.name}}</div>
        @if (city.flag) {
          <img class='hide-on-mobile' [src]="getImage(city?.flag)" style="height: 40px;">
        }</div>
      }
      @if (country) {
        <div class='hide-on-mobile flex' style="flex: 1 auto; margin: 14px;">
          <div>{{country?.name}}</div>
          @if (country.flag) {
            <img class='hide-on-mobile' src="../../../assets/images/{{country?.flag}}.svg" style="height: 33px;">
          }
        </div>
      }
      @if (impersonation) {
        <img style="height: 60px; cursor: pointer;padding-top: 5px;"
          src="../../../assets/images/userBack.svg" (click)="logIn()">
        }
        <button mat-button [matMenuTriggerFor]="userMenu"
          class="user-button">
          <div fxLayout="row" fxLayoutAlign="center center">
            @if (!logo) {
              <img class="avatar" src="assets/images/avatars/profile.jpg">
            }
            @if (logo) {
              <img class="avatar" [src]="getImage(logo)">
            }
            <span class="username mr-12" fxHide fxShow.gt-sm>{{userName}}</span>
            <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
          </div>
        </button>

        <mat-menu #userMenu="matMenu">

          <button mat-menu-item (click)="navigateToProfile()">
            <mat-icon>account_circle</mat-icon>
            <span>{{'main.myProfile' | translate }}</span>
          </button>
          <button mat-menu-item (click)="navigateToPrivacy()">
            <mat-icon>library_books</mat-icon>
            <span>{{'privacyInfo' | translate }}</span>
          </button>
          <button mat-menu-item class="" (click)="logOut()">
            <mat-icon>exit_to_app</mat-icon>
            <span>{{'main.logOut' | translate }}</span>
          </button>

        </mat-menu>
        <button mat-button fxHide fxShow.gt-xs
          class="language-button"
          [matMenuTriggerFor]="languageMenu">
          @if (selectedLanguage) {
            <div fxLayout="row" fxLayoutAlign="center center">
              <img class="flag mr-8" [src]="'assets/images/flags/'+selectedLanguage.flag+'.png'">
              <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
            </div>
          }
        </button>

        <mat-menu #languageMenu="matMenu">

          @for (lang of languages; track lang) {
            <button mat-menu-item (click)="setLanguage(lang)">
              <div fxLayout="row" fxLayoutAlign="start center">
                <img class="flag mr-16" [src]="'assets/images/flags/'+lang.flag+'.png'">
                <span class="iso">{{lang.title | translate}}</span>
              </div>
            </button>
          }

        </mat-menu>

        <button mat-icon-button
          class="mat-icon-button quick-panel-toggle-button"
          fuseMatSidenavToggler="quick-panel"
          aria-label="Toggle quick panel" (click)="openDocumentation()">
          <mat-icon class="icon">info</mat-icon>
        </button>

        <a href="{{websiteInfoLink}}" target="_blank">
          <button mat-icon-button
            class="mat-icon-button quick-panel-toggle-button">
            <mat-icon class="icon" svgIcon="lamp"></mat-icon>
          </button>
        </a>

      </div>
    <!--</div>-->
  </mat-toolbar>
